import { render, staticRenderFns } from "./HeaderVideo.vue?vue&type=template&id=aed93b04&lang=pug&"
import script from "./HeaderVideo.vue?vue&type=script&lang=js&"
export * from "./HeaderVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports